<template>
    <div>
        <card-header title="Sales Tax" icon="fa-file-invoice-dollar"/>

        <card-body>
            <card-list>
                <navigation-list-item
                    title="Payment Plan Taxes Progress"
                    icon="fa-file-invoice-dollar"
                    @click="$openCard('payment-plan-taxes', {}, card)"
                    :active="(child && child.definition.component === 'payment-plan-taxes')"/>

                <subheader-list-item icon="fa-chart-bar" title="Sales Tax Report"/>

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Start Date" label-position="inside">
                                <b-datepicker
                                    v-model="reportFilters.startDate"
                                    placeholder="Select start date"
                                    icon="calendar"
                                    :max-date="reportFilters.endDate || new Date()"
                                />
                            </b-field>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <b-field label="End Date" label-position="inside">
                                <b-datepicker
                                    v-model="reportFilters.endDate"
                                    placeholder="Select end date"
                                    icon="calendar"
                                    :min-date="reportFilters.startDate"
                                    :max-date="new Date()"
                                />
                            </b-field>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="date-shortcuts">
                                <a @click="setThisMonth">This Month</a>,
                                <a @click="setLastMonth">Last Month</a>,
                                <a @click="setThisYear">This Year</a>,
                                <a @click="setLastYear">Last Year</a>
                            </div>
                        </div>
                    </div>
                </container-list-item>

                <subheader-list-item icon="fa-list-check" title="Transaction Types"/>

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field>
                                <b-switch v-model="reportFilters.planTaxes">Payment Plans</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="reportFilters.courseEnrollments">Course Enrollments</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="reportFilters.resellerCarts">Reseller Cart Course Enrollments</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="reportFilters.courseApplications">Course Application Fees</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="reportFilters.confRegistrations">Conference Registrations</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="reportFilters.confApplications">Conference Application Fees</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="reportFilters.otherTransactions">Other Transactions</b-switch>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-success"
                        size="is-small"
                        @click="exportCsv"
                        class="mr-2"
                    ><i class="fas fa-file-csv mr-2"></i>Export CSV
                    </b-button>
                    <b-button
                        type="is-info"
                        size="is-small"
                        @click="viewReport"
                    ><i class="fas fa-eye mr-2"></i>View Report
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardFooter from "@/TIER/components/CardFooter";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import {client as http} from "@/http_client";
    import moment from "moment";

    export default {
        components: {
            CardHeader,
            CardBody,
            CardList,
            CardFooter,
            SubheaderListItem,
            NavigationListItem,
            SeparatorListItem,
            ContainerListItem
        },
        props: ['card', 'child'],
        data() {
            return {
                reportFilters: {
                    startDate: moment().startOf('month').toDate(),
                    endDate: new Date(),
                    planTaxes: true,
                    courseApplications: true,
                    confApplications: true,
                    confRegistrations: true,
                    resellerCarts: true,
                    courseEnrollments: true,
                    otherTransactions: true
                }
            }
        },
        computed: {
            selectedTransactionTypes: function() {
                const types = [];
                if (this.reportFilters.planTaxes) types.push('plan_taxes');
                if (this.reportFilters.courseApplications) types.push('course_applications');
                if (this.reportFilters.confApplications) types.push('conf_applications');
                if (this.reportFilters.confRegistrations) types.push('conf_registrations');
                if (this.reportFilters.resellerCarts) types.push('reseller_cart');
                if (this.reportFilters.courseEnrollments) types.push('course_enrollments');
                if (this.reportFilters.otherTransactions) types.push('other_transactions');
                return types;
            }
        },
        mounted: function () {
            this.$emit('loading', false);
        },
        methods: {
            setThisMonth: function() {
                this.reportFilters.startDate = moment().startOf('month').toDate();
                this.reportFilters.endDate = moment().endOf('month').toDate();
            },

            setLastMonth: function() {
                this.reportFilters.startDate = moment().subtract(1, 'month').startOf('month').toDate();
                this.reportFilters.endDate = moment().subtract(1, 'month').endOf('month').toDate();
            },

            setThisYear: function() {
                this.reportFilters.startDate = moment().startOf('year').toDate();
                this.reportFilters.endDate = moment().endOf('year').toDate();
            },

            setLastYear: function() {
                this.reportFilters.startDate = moment().subtract(1, 'year').startOf('year').toDate();
                this.reportFilters.endDate = moment().subtract(1, 'year').endOf('year').toDate();
            },

            viewReport: function() {
                console.log('Transaction Types:', this.selectedTransactionTypes);

                // Pass transaction types as pipe-separated string (can't use comma because card system uses commas)
                this.$openCard('sales-tax-report-results', {
                    startDate: this.reportFilters.startDate ? moment(this.reportFilters.startDate).format('YYYY-MM-DD') : null,
                    endDate: this.reportFilters.endDate ? moment(this.reportFilters.endDate).format('YYYY-MM-DD') : null,
                    transactionTypes: this.selectedTransactionTypes.join('|')
                }, this.card);
            },

            exportCsv: function() {
                this.$emit('loading', true);

                const payload = {
                    startDate: this.reportFilters.startDate ? moment(this.reportFilters.startDate).format('YYYY-MM-DD') : null,
                    endDate: this.reportFilters.endDate ? moment(this.reportFilters.endDate).format('YYYY-MM-DD') : null,
                    transactionTypes: this.selectedTransactionTypes
                };

                http.post('sales-tax/consolidated-report/csv', payload).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const dateStr = moment().format('YYYY-MM-DD');
                    link.setAttribute('download', `sales-tax-report-${dateStr}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.$emit('loading', false);
                }).catch(err => {
                    console.error('Error exporting CSV:', err);
                    window.alert('An error occurred while exporting the CSV.');
                    this.$emit('loading', false);
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .date-shortcuts {
        font-size: 0.85rem;
        color: #7a7a7a;

        a {
            color: #264d73;
            cursor: pointer;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }
</style>
